import { QuarantineSaveFormWebComponent } from './component/QuarantineSaveFormWebComponent';
import { WEB_COMPONENT_QUARANTINE_SAVE_FORM } from '../../../webcomponents.constants';

export { QuarantineSaveFormWebComponent };

window.customElements.define(WEB_COMPONENT_QUARANTINE_SAVE_FORM, QuarantineSaveFormWebComponent);
